import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Account } from 'src/app/interfaces';
import { AccountService } from 'src/app/services/account.service';
import { CloudinaryService } from 'src/app/services/cloudinary.service';

@Component({
  selector: 'vl-account',
  standalone: true,
  imports: [],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent {

  form = this.formBuilder.group({
    name: "",
    webhookUrl: "",
    redirectURIs: [],
    email: "",
  });

  private account: Account = <Account>{}

  constructor(
    private cloudinaryService: CloudinaryService, 
    private accountService: AccountService,
    private formBuilder: FormBuilder,
  ) {
    this.accountService.getAccount$().subscribe((account) => {
      this.account = account;
    })
  }

  open() {
    this.cloudinaryService.open((response: any) => {
      // console.log(response);
    })
  }

}
